import { Workflow, MessageSquareText, FolderCheck } from 'lucide-react';
import Reveal from './Reveal';
import { IMAGES } from '../../data/site';

const MINI = [
  { icon: Workflow, label: 'Organized workflows' },
  { icon: MessageSquareText, label: 'Simpler communication' },
  { icon: FolderCheck, label: 'Coordinated documentation' },
];

export const AgroTech = () => (
  <section data-testid="agrotech-section" className="relative py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-6">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.28em] text-gold">Modern Trade Process</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-4 font-display text-3xl font-medium leading-[1.12] tracking-tight text-ink sm:text-4xl lg:text-5xl">
            Agro + Trade, <span className="accent-italic font-semibold">connected.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-muted-foreground">
            We combine agricultural sourcing with organized, technology-enabled business processes — making
            communication, documentation and trade coordination simpler for every buyer we work with.
          </p>
        </Reveal>
        <div className="mt-9 space-y-4">
          {MINI.map((item, i) => (
            <Reveal key={item.label} delay={0.1 + i * 0.08}>
              <div className="flex items-center gap-4" data-testid={`agrotech-point-${i}`}>
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-sage-mist text-forest">
                  <item.icon className="h-5 w-5" />
                </span>
                <p className="text-sm font-bold text-ink">{item.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
      <div className="lg:col-span-6">
        <Reveal delay={0.1}>
          <div className="group relative">
            <div className="absolute -inset-4 -z-10 rounded-[3rem] bg-gold/10" />
            <div className="overflow-hidden rounded-[2.5rem] shadow-lift">
              <img
                src={IMAGES.agroTech}
                alt="Modern technology used alongside Indian agriculture"
                data-testid="agrotech-image"
                loading="lazy"
                className="aspect-[4/3] w-full object-cover transition-transform duration-[1.8s] ease-out group-hover:scale-105"
              />
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default AgroTech;
